import React from "react";
import clsx from "clsx";

import styles from "./ToggleSwitch.module.scss";

export type Props = {
  id: string;
  className?: string;
  name?: string;
  checked?: boolean;
  label: string;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const ToggleSwitch: React.FC<Props> = ({
  id,
  name,
  checked,
  className,
  label,
  disabled,
  onChange,
}) => {
  return (
    <div className={clsx(styles.switch, className)}>
      <input
        type="checkbox"
        id={`checkbox-${id}`}
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <label
        htmlFor={`checkbox-${id}`}
        data-checked={label}
        data-uncheck={label}
      />
    </div>
  );
};

export default ToggleSwitch;
